import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, toDisplayString, normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "average-rating-bar__wrapper"
};
const _hoisted_2 = {
  class: "average-rating-bar__title"
};
const _hoisted_3 = {
  class: "average-rating-bar__labels"
};
const _hoisted_4 = {
  class: "average-rating-bar__labels--max"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsAverageRatingBar",
  props: {
    id: {},
    averageRating: {},
    valueRange: {},
    maxLabel: {},
    minLabel: {},
    label: {}
  },
  setup(__props) {
    const props = __props;
    const progress = computed(() => props.averageRating / props.valueRange);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("h2", _hoisted_2, toDisplayString(props.label), 1), createElementVNode("div", {
        class: "average-rating-bar__bar",
        style: normalizeStyle({
          "--progress-value": progress.value
        })
      }, null, 4), createElementVNode("div", _hoisted_3, [createElementVNode("span", null, toDisplayString(props.minLabel), 1), createElementVNode("span", _hoisted_4, toDisplayString(props.maxLabel), 1)])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsAverageRatingBar2.mjs.map
